import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import ImageViewer from '../image/ImageViewer';
import api from '../../services/api';
import { scheduleIdle } from '../../utils/scheduleIdle';
import './RightPanel.css';

const RightPanel = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const [data, setData] = useState(null);

    useEffect(() => {
        return scheduleIdle(() => {
            api.get('/widget').then(r => setData(r.data)).catch(() => {});
        }, 1400);
    }, []);

    const handleVote = (widgetId, optionId) => {
        if (!user) return;
        api.post(`/widget/${widgetId}/vote/${optionId}`)
            .then(r => {
                setData(prev => ({
                    ...prev,
                    widget: {
                        ...prev.widget,
                        options: r.data,
                        userVoteOptionId: optionId
                    }
                }));
            })
            .catch(() => {});
    };

    return (
        <aside className="right-panel">
            <div className="right-panel__widget">
                {data?.widget
                    ? <WidgetContent widget={data.widget} user={user} onVote={handleVote} t={t} />
                    : data?.topComments?.length > 0
                        ? <TopComments comments={data.topComments} t={t} />
                        : null
                }
            </div>
            <div className="right-panel__contacts">
                <span className="right-panel__contacts-label">{t('widget.contacts', { defaultValue: 'Контакты' })}</span>
                <a href="mailto:hello@p1xel.su" className="right-panel__email">cipherhhh@gmail.com</a>
            </div>
        </aside>
    );
};

const WidgetContent = ({ widget, user, onVote, t }) => {
    const totalVotes = widget.options?.reduce((s, o) => s + o.voteCount, 0) ?? 0;

    return (
        <div className="widget">
            {widget.title && <div className="widget__title">{widget.title}</div>}

            {widget.type === 'Image' && widget.imageUrl && (
                <ImageViewer src={widget.imageUrl} alt={widget.title ?? ''} className="widget__image" />
            )}

            {widget.type === 'News' && (
                <>
                    {widget.imageUrl && (
                        <ImageViewer src={widget.imageUrl} alt={widget.title ?? ''} className="widget__image" />
                    )}
                    {widget.content && <p className="widget__text">{widget.content}</p>}
                </>
            )}

            {widget.type === 'Text' && widget.content && (
                <p className="widget__text">{widget.content}</p>
            )}

            {widget.type === 'Poll' && widget.options && (
                <div className="widget__poll">
                    {widget.options.map(opt => {
                        const voted = widget.userVoteOptionId === opt.id;
                        const pct = totalVotes > 0 ? Math.round((opt.voteCount / totalVotes) * 100) : 0;
                        const revealed = widget.userVoteOptionId != null;
                        return (
                            <button
                                key={opt.id}
                                className={`poll-option ${voted ? 'poll-option--voted' : ''} ${revealed ? 'poll-option--revealed' : ''}`}
                                onClick={() => !revealed && onVote(widget.id, opt.id)}
                                disabled={revealed || !user}
                            >
                                {revealed && (
                                    <div
                                        className="poll-option__bar"
                                        style={{ width: `${pct}%` }}
                                    />
                                )}
                                <span className="poll-option__text">{opt.text}</span>
                                {revealed && <span className="poll-option__pct">{pct}%</span>}
                            </button>
                        );
                    })}
                    {!user && <p className="widget__hint">{t('widget.login_to_vote', { defaultValue: 'Войдите, чтобы проголосовать' })}</p>}
                </div>
            )}
        </div>
    );
};

const TopComments = ({ comments, t }) => (
    <div className="widget">
        <div className="widget__title">{t('widget.top_today', { defaultValue: 'Топ за сегодня' })}</div>
        <div className="top-comments">
            {comments.map(c => (
                <Link key={c.id} to={`/post/${c.postId}`} className="top-comment">
                    <div className="top-comment__meta">
                        <span className="top-comment__author">{c.authorUsername}</span>
                        <span className="top-comment__score">+{c.score}</span>
                    </div>
                    <div className="top-comment__post">{c.postTitle}</div>
                    <div className="top-comment__text">{c.content}</div>
                </Link>
            ))}
        </div>
    </div>
);

export default RightPanel;
